import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AlertaModal } from 'src/app/componentes/componentes-funcionais/alerta-modal/alerta-modal.component';
import Swal from 'sweetalert';

@Injectable({
  providedIn: 'root',
})
export class ErroService {
  constructor() {}

  retornoErro(erro: any) {
    const status = erro?.status;
    const msg = erro?.error?.Mensagem || erro?.message;

    if (status === 401) {
      return;
    }

    Swal('Erro', msg, 'error');
  }
  }

